import { FC, memo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import includes from 'lodash/includes';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Modal from 'antd/lib/modal/Modal';

import { StatusCanceledIcn } from 'utils/icons';

interface ICustomPromptProps {
  rootPath: string;
  isNeedBlock: boolean;
  onResetFields: () => void;
  setIsTouched: (isTouched: boolean) => void;
}

interface ICurrentPath {
  pathname: string;
  search: string;
}

const CustomPrompt: FC<ICustomPromptProps> = ({ isNeedBlock, rootPath, onResetFields, setIsTouched }) => {
  const { location, block, push } = useHistory();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentPath, setCurrentPath] = useState<ICurrentPath>({} as ICurrentPath);

  const handleStay = () => setIsOpen(false);

  const handleAway = () => {
    block(() => {});
    push(currentPath);
    setIsOpen(false);
    setIsTouched(false);
    onResetFields();
  };

  useEffect((): () => void => {
    if (isNeedBlock) {
      block(({ pathname, search }) => {
        if (!includes(search, rootPath)) {
          setCurrentPath({ pathname, search });
          setIsOpen(true);

          return 'true';
        }
      });
    } else {
      block(() => {});
    }

    return () => block(() => {});
  }, [location, isNeedBlock]);

  return (
    <Modal closable centered width="auto" footer={null} open={isOpen} onCancel={handleStay}>
      <div className="text-center">
        <StatusCanceledIcn className="w-24 h-24 text-orange-50 mx-auto" />
        <h1>Are you sure?</h1>
        <p>
          You have made changes to the content in this tab, but haven’t saved them.<br />
          If you don’t save the edits to this form,<br />
          any data you entered may be lost.
        </p>
        <Divider />
        <div className="flex items-center justify-between">
          <Button type="link" className="p-0 text-black-70 dark:text-black-30" onClick={handleAway}>Switch Away</Button>
          <Button size="large" type="primary" onClick={handleStay}>Continue Editing</Button>
        </div>
      </div>
    </Modal>
  );
};

export default memo(CustomPrompt);
